import {
  IClientGeneralLedgerMapping,
  IClientGeneralLedgerDilutionOverTimeData,
  IDilutionDropwdowns,
  IWholesaleDilutionMonth,
} from '@common/interfaces/clientGeneralLedger'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import { DOWNLOAD_TEMPLATE_REQUEST } from '../bbc/actions'
import * as actions from './actions'

export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix, DOWNLOAD_TEMPLATE_REQUEST.replace('_REQUEST', '')],
    [actions.LIST_TYPE_MAPPING_REQUEST, actions.UPDATE_TYPE_MAPPING_REQUEST],
  ),
  typeOptions(state: { name: string }[] = [], action: IAction): { name: string }[] {
    switch (action.type) {
      case actions.LIST_TYPES_SUCCESS:
        return action.data as { name: string }[]
      default:
        return state
    }
  },
  typeMapping: createLoadingDataReducer<{
    data: IClientGeneralLedgerMapping[]
  }>([actions.LIST_TYPE_MAPPING_REQUEST], [actions.UPDATE_TYPE_MAPPING_REQUEST], false, [
    actions.HIDE_TYPE_MAPPING,
  ]),
  dilutionOverTime: createLoadingDataReducer<IClientGeneralLedgerDilutionOverTimeData>(
    [actions.LIST_DILUTION_OVER_TIME_REQUEST],
    [],
    false,
    [actions.HIDE_DILUTION_OVER_TIME],
  ),
  dilutionDropdowns: createLoadingDataReducer<IDilutionDropwdowns>(
    [actions.LIST_DILUTION_DROPDOWNS_REQUEST],
    [],
    false,
    [actions.HIDE_DILUTION_DROPDOWNS],
  ),
  wholesaleDilution: createLoadingDataReducer<IWholesaleDilutionMonth[]>(
    [actions.LIST_WHOLESALE_DILUTION_REQUEST],
    [],
    false,
    [],
  ),
})
